// BARCINO — Champ téléphone avec intl-tel-input
// Sélecteur : input[data-phone-input]
// Flags sprite : /dist/img/flags.webp
// import() dynamique : intl-tel-input pèse ~75 Ko et n'est utile que sur les
// pages avec un champ téléphone (compte, commande) — évite de le charger
// partout ailleurs (accueil, catalogue, diagnostic…).

const barcinoPhone = {
    instances: [],

    async init() {
        const inputs = document.querySelectorAll('input[data-phone-input]');
        if (!inputs.length) return;

        const { default: intlTelInput } = await import('intl-tel-input/intlTelInputWithUtils');

        inputs.forEach(input => {
            input.setAttribute('autocomplete', 'off');

            const iti = intlTelInput(input, {
                initialCountry:     'fr',
                preferredCountries: ['fr', 'be', 'ch', 'lu'],
                separateDialCode:   true,
                formatAsYouType:    true,
                nationalMode:       true,
                customPlaceholder:  () => '6 00 00 00 00',
                i18n:               { searchPlaceholder: 'Rechercher un pays' },
                imagePath:          '/dist/img/',
            });

            this.instances.push(iti);

            const cleanAutofill = () => {
                const raw = input.value;
                if (raw && /\$\d/.test(raw)) {
                    const digits = raw.replace(/[^\d+]/g, '');
                    if (digits) {
                        iti.setNumber(digits.startsWith('+') ? digits : '+' + digits);
                    } else {
                        input.value = '';
                    }
                }
            };

            input.addEventListener('change', cleanAutofill);
            setTimeout(cleanAutofill, 500);

            const form = input.closest('form');
            if (form) {
                form.addEventListener('submit', () => {
                    cleanAutofill();
                    input.value = iti.getNumber();
                }, { once: false });
            }
        });
    },

    destroy() {
        this.instances.forEach(iti => iti.destroy());
        this.instances = [];
    },
};

export default barcinoPhone;
